import { BASE_URL } from "../config";

export async function loginAPI(email, password) {
  try {
    const response = await fetch(`${BASE_URL}api/accounts/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.message || "Login failed");

    return data;
  } catch (error) {
    throw new Error(error.message || "Something went wrong");
  }
}

export async function forgotPasswordAPI(email) {
  const res = await fetch(`${BASE_URL}api/accounts/forgot-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Error sending reset link");
  return data;
}

export async function resetPasswordAPI(uid, token, password) {
  const res = await fetch(`${BASE_URL}api/accounts/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ uid, token, password }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Reset failed");
  return data;
}

export async function updatePasswordAPI(token, password) {
  const res = await fetch(`${BASE_URL}api/accounts/update-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ password }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to update password");
  return data;
}

